import React from 'react';
import PropTypes from 'prop-types';
import EquipmentOptionsList from './EquipmentOptionsList';
import SecurityOptionsList from './SecurityOptionsList';

const EquipmentOptionsPanel = (props) => {
    const {
        equipmentOptions,
        billingSystem,
        orderId,
        accountNumber,
        workOrderActions,
        techId,
        equipmentDetails,
    } = props;

    return (
        <div>
            <EquipmentOptionsList
                orderId={orderId}
                accountNumber={accountNumber}
                billingSystem={billingSystem}
                equipmentOptions={equipmentOptions}
                workOrderActions={workOrderActions}
                techId={techId}
                equipmentDetails={equipmentDetails}
            />
            <SecurityOptionsList
                orderId={orderId}
                equipmentOptions={equipmentOptions}
                workOrderActions={workOrderActions}
            />
        </div>


    );
};

EquipmentOptionsPanel.propTypes = {
    billingSystem: PropTypes.string,
    equipmentOptions: PropTypes.object,
    workOrderActions: PropTypes.object,
    techId: PropTypes.string,
    orderId: PropTypes.string,
    accountNumber: PropTypes.string,
    equipmentDetails: PropTypes.object
};

export default EquipmentOptionsPanel;


// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentOptionsPanel.js